import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { computed, watch } from "vue";

import { useAsync } from "@/use/useAsync";
import { useScore } from "@/use/useScore";
import { useStore } from "@/use/useStore";
import { formatCurrency, formatDate } from "@/utils";

import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiTitle from "@/plugins/ui/components/typography/UiTitle.vue";
import AccountBalanceLimit from "./AccountBalanceLimit.vue";
import { usePermissions } from "@/use/usePermissions";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountBalance',
  setup(__props) {

const { isAllow } = usePermissions();
const { currentUser } = useStore();
const { score, fetchScore } = useScore();

const fetchData = useAsync(fetchScore, true);

const modification = computed(() => {
  const modification = formatDate(score.value?.modification);
  return "Обновлено: " + modification;
});

const balance = computed(() => {
  const available = score.value?.balance || 0;
  return formatCurrency(available / 100);
});

watch(() => currentUser.value?.id, fetchData.execute);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiCard, _mergeProps(_ctx.$attrs, { class: "account-balance" }), {
    header: _withCtx(() => [
      _createVNode(UiHeader, { title: "Баланс" })
    ]),
    default: _withCtx(() => [
      _createVNode(UiTitle, {
        weight: "bold",
        class: "account-balance__value"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(balance)), 1)
        ]),
        _: 1
      }),
      _createVNode(UiCaption, { weight: "medium" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(modification)), 1)
        ]),
        _: 1
      }),
      (_unref(isAllow)('score_limit'))
        ? (_openBlock(), _createBlock(AccountBalanceLimit, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}
}

})